import React from 'react';
import { Box, Grid } from '@mui/material';
import './Shimmer.css';
import './PromotionShimmer.css';

const ShimmerBox = ({ width, height, sx }) => (
    <Box className="shimmer" sx={{ width, height, ...sx }} />
);

const PromotionCardShimmer = () => (
    <Box className="promotion-shimmer-card">
        <Box className="promotion-shimmer-header">
            <ShimmerBox className="promotion-shimmer-title" />
            <ShimmerBox className="promotion-shimmer-status" />
        </Box>
        <Box className="promotion-shimmer-content">
            <ShimmerBox className="promotion-shimmer-line" width="80%" />
            <ShimmerBox className="promotion-shimmer-line" width="90%" />
            <ShimmerBox className="promotion-shimmer-line" width="70%" />
        </Box>
        <Box className="promotion-shimmer-actions">
            <ShimmerBox className="promotion-shimmer-button" />
            <ShimmerBox className="promotion-shimmer-button" />
        </Box>
    </Box>
);

export default function RestaurantPromotionShimmer() {
    return (
        <Box sx={{ py: 3 }}>
            <Grid container spacing={3}>
                {[...Array(3)].map((_, index) => (
                    <Grid item xs={12} key={index}>
                        <PromotionCardShimmer />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}
